export const LineChip = ({ text, color, textColor, extraStyles }: { text: string, color: string, textColor: string, extraStyles: object }) => (
    <span
        style={{
            fontSize: '1.2em',
            borderRadius: '1em',
            padding: '.1em .4em',
            color: textColor,
            backgroundColor: color,
            ...extraStyles,
        }}
    >
        {text}
    </span>
)
